module.exports = __webpack_public_path__ + "img/logo3.139fb760.png";